import { useState } from "react";
import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import MarqueeRibbon from "../components/MarqueeRibbon";
import CalculatorSection from "../components/CalculatorSection";
import ServicesSection from "../components/ServicesSection";
import GallerySection from "../components/GallerySection";
import AboutSection from "../components/AboutSection";
import ProcessSection from "../components/ProcessSection";
import FaqSection from "../components/FaqSection";
import CoverageLinksSection from "../components/CoverageLinksSection";
import FooterSection from "../components/FooterSection";
import FloatingActions from "../components/FloatingActions";
import ChatWidget from "../components/ChatWidget";
import QuoteFormModal from "../components/QuoteFormModal";

export default function HomePage() {
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [quotePrefill, setQuotePrefill] = useState(null);
  const openQuote = (prefill = null) => {
    setQuotePrefill(prefill);
    setQuoteOpen(true);
  };

  return (
    <div id="top" className="bg-hydro-navy text-slate-100 font-body antialiased overflow-x-clip">
      <Navbar />
      <main>
        <HeroSection />
        <MarqueeRibbon />
        <CalculatorSection onOpenQuote={openQuote} />
        <ServicesSection />
        <GallerySection />
        <AboutSection />
        <ProcessSection />
        <FaqSection />
        <CoverageLinksSection />
      </main>
      <FooterSection onOpenQuote={openQuote} />
      <FloatingActions />
      <ChatWidget />
      <QuoteFormModal open={quoteOpen} onOpenChange={setQuoteOpen} prefill={quotePrefill} />
    </div>
  );
}
